import { Fragment } from "react/jsx-runtime"
import { Temporal } from "@imago/api-client"
import { SubmitButton } from "@imago/api-client-for-react"
import { GAHTTreatmentFeedbackContent, ProductID, ServiceID, UserServicesRequestContent, TEMPORARILY_HERE_advertisedServices as advertisedServices } from "@imago/model"
import { useNow } from "../../../queries/Now.ts"
import { useLastGAHTTreatmentFeedback, useSubmitDocuments } from "../../../queries/user-emrs.ts"

function useYourExperienceDescribed() {
	const lastFeedback = useLastGAHTTreatmentFeedback()
	const now = useNow('hour')
	if (lastFeedback === undefined) return
	return !!lastFeedback && Temporal.Instant.compare(lastFeedback, now.subtract({months: 1}).toInstant()) > 0
}

const QUESTIONS = [
	{
		question: "How have you been managing with your medication?",
		required: true,
		rows: 5,
	},
	{
		question: "Have you been experiencing / struggling with any side effects or have any positive changes you have seen?",
		required: true,
		rows: 5,
	},
	{
		question: "Are you happy with your doses and medications etc, how do you feel these are working for you?",
		required: true,
		rows: 5,
	},
	{
		question: "Please also let us know if you have had any health changes since your last prescription, or started any new medications, or undergone any medical procedures or surgeries since your last follow-up.",
		required: true,
		rows: 5,
	},
	{
		question: "Do you have any other feedback on your treatment you would like to pass on?",
		required: false,
		rows: 5,
	},
	{
		question: "Please confirm if there have been any changes to your details since your last prescription (Legal name, Address, ID number if applicable, or allergy status)",
		required: false,
		rows: 3,
	},
]

function _DescribeYourExperience() {
	const submitDocuments = useSubmitDocuments()

	return <form>
		{QUESTIONS.map((q, i) => <Fragment key={i}>
			<h6 style={!q.required ? {fontWeight: 'normal'} : {}}>{q.question}</h6>
			<label>
				<textarea name={`q${i}`} required={q.required} rows={q.rows}/>
			</label>
		</Fragment>)}
		<h6 style={{fontWeight: 'normal'}}>If you are interested in vocal coaching or mental health counselling, please let us know here</h6>
		{advertisedServices.map((service => <label key={service.ID}>
			<input type="checkbox" name={service.ID}/> {service.title}
		</label>))}
		<SubmitButton
			mutation={submitDocuments}
			vars={data => {
				const gahtTreatmentFeedback = [] as unknown as GAHTTreatmentFeedbackContent
				for (const [i, q] of QUESTIONS.entries()) {
					gahtTreatmentFeedback.push({class: 'HEADING_2', text: q.question})
					gahtTreatmentFeedback.push({class: 'NORMAL_TEXT', text: (data.get(`q${i}`) as string) ?? ''})
					gahtTreatmentFeedback.push({class: 'NORMAL_TEXT', text: ''})
				}
				let userServicesRequest: UserServicesRequestContent | undefined = {services: new Set<ProductID & ServiceID>()}
				for (const service of advertisedServices) {
					if (data.get(service.ID)) {
						userServicesRequest.services.add(service.ID)
					}
				}
				if (!userServicesRequest.services.size) {
					userServicesRequest = undefined
				}
				return {
					gahtTreatmentFeedback,
					userServicesRequest,
				}
			}}
		>
			Send
		</SubmitButton>
	</form>
}

export function DescribeYourExperience() {
	const done = useYourExperienceDescribed()
	return <section data-done={done ? true : undefined}>
		<h2>Describe your experience</h2>
		{!done ? <_DescribeYourExperience/> : <></>}
	</section>
}
